import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2, X } from "lucide-react";
import { authApi, setToken, formatApiErrorDetail } from "../lib/auth";

export const ChangePasswordModal = ({ onClose }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) return setError("Le nuove password non coincidono");
    if (next.length < 8) return setError("La nuova password deve avere almeno 8 caratteri");
    setSaving(true);
    setError("");
    try {
      const r = await authApi.changePassword(current, next);
      setToken(r.token);
      toast.success("Password aggiornata");
      onClose();
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  const field = (label, val, set, testid) => (
    <div>
      <label className="block text-xs font-medium text-slate-600 mb-1">{label}</label>
      <input type="password" value={val} onChange={(e) => set(e.target.value)} data-testid={testid}
        className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500/40" />
    </div>
  );

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} data-testid="change-password-modal" className="bg-white rounded-xl w-full max-w-sm p-6 shadow-2xl space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-display font-semibold text-lg flex items-center gap-2"><KeyRound className="w-5 h-5 text-orange-600" /> Cambia password</h3>
          <button type="button" onClick={onClose} data-testid="change-password-close" className="text-slate-400 hover:text-slate-700"><X className="w-5 h-5" /></button>
        </div>
        {field("Password attuale", current, setCurrent, "change-password-current")}
        {field("Nuova password (min. 8 caratteri)", next, setNext, "change-password-new")}
        {field("Conferma nuova password", confirm, setConfirm, "change-password-confirm")}
        {error && <p data-testid="change-password-error" className="text-sm text-red-600">{error}</p>}
        <button type="submit" disabled={saving || !current || !next} data-testid="change-password-submit"
          className="w-full inline-flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white text-sm font-semibold py-2.5 rounded-lg">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />} Aggiorna password
        </button>
      </form>
    </div>
  );
};
